"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.weak-map");
var _layout = _interopRequireDefault(require("@/layout"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
var GaGaCommunity = {
  path: '/GaGaCommunity',
  component: _layout.default,
  redirect: '/GaGaCommunity/operationsManagement',
  name: 'GaGaCommunity',
  alwaysShow: true,
  meta: {
    title: 'GA社区',
    icon: 'GaGaCommunity'
  },
  children: [{
    path: 'operationsManagement',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/GaGaCommunity/operationsManagement/index.vue'));
      });
    },
    name: 'operationsManagement',
    meta: {
      title: '业务配置'
    }
  }, {
    path: 'CommunityDynamics',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/GaGaCommunity/CommunityDynamics/index.vue'));
      });
    },
    name: 'CommunityDynamics',
    meta: {
      title: '社区动态',
      icon: ''
    }
  }, {
    path: 'AvatarManagement',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/GaGaCommunity/AvatarManagement/index.vue'));
      });
    },
    name: 'AvatarManagement',
    meta: {
      title: '形象管理',
      icon: ''
    }
  }, {
    path: 'TopicManagement',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/GaGaCommunity/TopicManagement/index.vue'));
      });
    },
    name: 'TopicManagement',
    meta: {
      title: '话题管理',
      icon: ''
    }
  }, {
    path: 'ActivityTemplate',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/GaGaCommunity/ActivityTemplate/ActivityTemplate.vue'));
      });
    },
    name: 'ActivityTemplate',
    meta: {
      title: '活动模板',
      icon: ''
    }
  }, {
    path: 'CreateActivityTemplate',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/GaGaCommunity/ActivityTemplate/CreateActivityTemplate.vue'));
      });
    },
    name: 'CreateActivityTemplate',
    meta: {
      title: '新增活动模板',
      icon: ''
    },
    hidden: true
  }, {
    path: 'CommunityDynamics/detail/:id',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/GaGaCommunity/CommunityDynamics/DetailView.vue'));
      });
    },
    name: 'CommunityDynamicsDetail',
    meta: {
      title: '社区动态详情',
      icon: ''
    },
    hidden: true
  }, {
    path: 'gift_card',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/GaGaCommunity/gift_card/GiftCardIndex.vue'));
      });
    },
    name: 'GiftCard',
    meta: {
      title: '礼品卡',
      icon: ''
    }
  }, {
    path: 'physical_card',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/GaGaCommunity/gift_card/PhysicalCardIndex.vue'));
      });
    },
    name: 'PhysicalCard',
    meta: {
      title: '实体卡',
      icon: ''
    }
  }
  // {
  //   path: 'MemberDay',
  //   component: () => import('@/views/GaGaCommunity/MemberDay/MemberDayIndex.vue'),
  //   name: 'MemberDay',
  //   meta: { title: '会员日活动', icon: '', hidden: true }
  // }
  ]
};
var _default = exports.default = GaGaCommunity;